<template>

  
		<div class="card-novo-usuario justify-content-center">
			<div class="card shadow-22">								
				<h1>Acesso Restrito</h1>


				<transition-group name="p-messages" tag="div">
					<Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
				</transition-group>

				<div class="p-fluid formgrid grid">
					
 			<ValidationObserver v-slot="{ handleSubmit }">
    		<form @submit.prevent="handleSubmit(efetuarLoginLdap)"> 
				
				<div class="field">
					<ValidationProvider name="Login" rules="required" v-slot="{ errors }" mode="lazy">
						<label for="">Login</label>	
						<span class="p-input-icon-left">
						<i class="pi pi-user" />
						<InputText 
							id="username" 
							placeholder="Login..."  
							v-model="usuario.username" 
							:class="{ 'field-invalid': errors[0] }" 
							style="width: 300px"/>						
						</span>							
						<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
					</ValidationProvider>
				</div>

				<div class="field">
					<ValidationProvider name="Senha" rules="required" v-slot="{ errors }" mode="lazy">
						<label for="">Senha</label>
						<span class="p-input-icon-left">
						<i class="pi pi-lock" />	
						<InputText id="senha" v-model="usuario.senha" type="password" placeholder="Senha ..." 
						:class="{ 'field-invalid': errors[0] }" style="width: 300px"/>															
						</span>	
						<InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
					</ValidationProvider>	
				</div>
				<vue-recaptcha ref="recaptcha" sitekey="6LcajvUpAAAAAHba3Xr9Ov6ob_2TUgw6W3NgEHQZ"  @verify="onVerify"/>
				<Button label="Login" icon="pi pi-check" type="submit" style="width: 140px" :disabled="verificaRecaptcha"/>	
				<router-link :to="{ name: 'login'}">
                    	<Button label="Voltar" icon="pi pi-cancel" class="p-button-secondary ml-4" style="width: 140px"/>	
                </router-link>
				
			</form>
		</ValidationObserver>	

  

	</div>
    </div>
</div>

</template>

<script>
import { validacaoFormulario } from '@/validacaoFormulario'
import { tratamentoDeErros } from '@/tratamentoDeErros'
import { VueRecaptcha } from 'vue-recaptcha';

export default {

mixins: [validacaoFormulario, tratamentoDeErros],
components: { VueRecaptcha },

data() {
        return {
			messages: [],
            usuario: {
                username: '',
                senha: ''
            },
			recaptchaToken: '',
			verificaRecaptcha: true
        };
    },

    methods: {		
		onVerify(token) {
				this.recaptchaToken = token;
				if(this.recaptchaToken){
					this.verificaRecaptcha = false;
				}
			},
		efetuarLoginLdap(){		
			if (!this.recaptchaToken) {
					alert('Please complete the reCAPTCHA');
				return;
				}				
			this.$store.dispatch('efetuarLoginLdap', this.usuario)
				.then( ()  => {							
					this.$router.push( { name: 'home' });						
				} )
				.catch(erro =>  {
					this.messages = this.getMessagesError(erro);
					console.log();
				})
		}
	} 
}
</script>